import { useState, useEffect, useContext } from 'react';
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";



// Image imports
import flow_CP from '../../../../Assets/Images/LeadershipFlowImg/flow_CP.png';
import flow_CS from '../../../../Assets/Images/LeadershipFlowImg/flow_CS.png';
import flow_CV from '../../../../Assets/Images/LeadershipFlowImg/flow_CV.png';
import flow_PC from '../../../../Assets/Images/LeadershipFlowImg/flow_PC.png';
import flow_PS from '../../../../Assets/Images/LeadershipFlowImg/flow_PS.png';
import flow_PV from '../../../../Assets/Images/LeadershipFlowImg/flow_PV.png';
import flow_SC from '../../../../Assets/Images/LeadershipFlowImg/flow_SC.png';
import flow_SP from '../../../../Assets/Images/LeadershipFlowImg/flow_SP.png';
import flow_SV from '../../../../Assets/Images/LeadershipFlowImg/flow_SV.png';
import flow_VC from '../../../../Assets/Images/LeadershipFlowImg/flow_VC.png';
import flow_VP from '../../../../Assets/Images/LeadershipFlowImg/flow_VP.png';
import flow_VS from '../../../../Assets/Images/LeadershipFlowImg/flow_VS.png';


import GroupReportContext from '../../../../Context/GroupReportContext';
import { applyFullTieOrder } from '../../../../utils/quadrantTieOrder';

const BOX_WIDTH = 84.2;
const BOX_HEIGHT = 38.63;
const ARROW_WIDTH = 70;
const BOX_RADIUS = 16;
const BOX_PADDING = '6px 8px 3px 8px';
const LABEL_FONT = { fontFamily: 'Lato, sans-serif', fontWeight: 700, fontSize: "13px", lineHeight: "13px", color: '#245775', marginTop: "4.82px", textAlign: 'center', letterSpacing: 0 };
const PERCENT_FONT = { fontFamily: 'Lato, sans-serif', fontWeight: 400, fontSize: "13px", lineHeight: "13px", letterSpacing: 0, color: '#5795B2', marginTop: "1.3px", textAlign: 'center', };
const START_FONT = { fontFamily: 'Lato, sans-serif', fontWeight: 700, fontSize: "8.34px", lineHeight: "8.34px", color: '#245775', marginBottom: "5.14px", textAlign: 'center', letterSpacing: 0 };
const COLORS = { 'collaborative': '#D04B2F', 'strategic': '#7A8793', 'visionary': '#2B5C73', 'performance': '#C89B2B' };

const Arrow = () => (
  <svg width="70" height="24" viewBox="0 0 70 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: 'middle' }}>
    <line x1="0" y1="12" x2="70" y2="12" stroke="#245775" strokeWidth="3" />
    <path d="M30 3L40 12L30 21" fill="none" stroke="#245775" strokeWidth="3" />
  </svg>
);

function SelfLeadershipFlowDiagram({ leadershipSnapshotResults, leadershipLabels }) {
  // console.log("SelfLeadershipFlowDiagram - leadershipSnapshotResults:", leadershipSnapshotResults);
  // console.log("SelfLeadershipFlowDiagram - leadershipLabels:", leadershipLabels);

  if (!leadershipSnapshotResults || !leadershipLabels || leadershipSnapshotResults.length === 0 || leadershipLabels.length === 0) {
    return <div>Loading...</div>;
  }

  const paired = leadershipLabels?.map((label, i) => ({
    label,
    percent: leadershipSnapshotResults?.[i],
  }));
  const sorted = paired.sort((a, b) => b.percent - a.percent);
  const steps = sorted.map(({ label, percent }) => ({
    title: label.toUpperCase(),
    subtitle: 'Leader',
    label: label.charAt(0).toUpperCase() + label.slice(1),
    percent: `${(Number(percent) || 0).toFixed(2)}%`,
    color: COLORS[label.toLowerCase()]
  }));
  const columns = [];
  for (let i = 0; i < steps.length; i++) {
    columns.push({ type: 'box', step: steps[i], idx: i });
    if (i < steps.length - 1) {
      columns.push({ type: 'arrow', idx: i });
    }
  }
  return (
    <div style={{ margin: '8px auto', display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative' }}>
      <div style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'center', alignItems: 'flex-end' }}>
        {columns.map((col, idx) => (
          col.type === 'box' ? (
            <div key={'start-' + idx} style={{ width: BOX_WIDTH, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              {col.idx === 0 ? (
                <span style={START_FONT}>Start</span>
              ) : (
                <span style={{ height: 16, marginBottom: 6 }}></span>
              )}
            </div>
          ) : (
            <div key={'start-arrow-' + idx} style={{ width: ARROW_WIDTH }}></div>
          )
        ))}
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'center', alignItems: 'center', position: 'relative', zIndex: 1 }}>
        {columns.map((col, idx) => (
          col.type === 'box' ? (
            <div key={'box-' + idx} style={{ width: BOX_WIDTH, display: 'flex', flexDirection: 'column', alignItems: 'center', zIndex: 2 }}>
              <div style={{ background: col.step.color, color: '#fff', borderRadius: BOX_RADIUS, padding: BOX_PADDING, fontWeight: 700, fontSize: 18, width: BOX_WIDTH, height: BOX_HEIGHT, minWidth: BOX_WIDTH, textAlign: 'center', boxShadow: '0 2px 8px rgba(0,0,0,0.15)', fontFamily: 'Lato, sans-serif', letterSpacing: 0, zIndex: 2, position: 'relative', backgroundColor: col.step.color, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <div style={{ fontSize: 10, lineHeight: '12px' }}>{col.step.title}</div>
                <div style={{ fontWeight: 700, fontSize: 8, lineHeight: '10px', letterSpacing: 1 }}>{col.step.subtitle.toUpperCase()}</div>
              </div>
            </div>
          ) : (
            <div key={'arrow-' + idx} style={{ width: ARROW_WIDTH, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'transparent', zIndex: 1, position: 'relative', margin: '0 -1px' }}>
              <Arrow />
            </div>
          )
        ))}
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'center', alignItems: 'flex-start', position: 'relative', zIndex: 2, backgroundColor: '#fff' }}>
        {columns.map((col, idx) => (
          col.type === 'box' ? (
            <div key={'label-' + idx} style={{ width: BOX_WIDTH, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div style={LABEL_FONT}>{col.step.label}</div>
              <div style={PERCENT_FONT}>{col.step.percent}</div>
            </div>
          ) : (
            <div key={'label-arrow-' + idx} style={{ width: ARROW_WIDTH }}></div>
          )
        ))}
      </div>
    </div>
  );
}

export default function LeadershipFlowPreview360({ apiData, reportType, pageNumber }) {
  // console.log("apiData", apiData);
  const [leadershipSnapshotResults, setLeadershipSnapshotResults] = useState([]);
  const [variablsMapArray, setVariableMapArray] = useState();
  const [leadershipLabels, setLeadershipLabels] = useState([]);
  const [highestLeadership, setHighestLeadership] = useState("");
  const [aggregated360Results, setAggregated360Results] = useState([]);
  const [aggregated360Labels, setAggregated360Labels] = useState([]);
  const [aggregated360Highest, setAggregated360Highest] = useState("");

  const [selfScoreRanking, setSelfScoreRanking] = useState([]);
  const [selfAverages, setSelfAverages] = useState({ strategic: 0, visionary: 0, performance: 0, collaborative: 0 });
  const [three60ScoreRanking, setThree60ScoreRanking] = useState([]);
  const [three60Averages, setThree60Averages] = useState({ strategic: 0, visionary: 0, performance: 0, collaborative: 0 });
  const { averagePercentagesLeadership } = useContext(GroupReportContext)

  const leadershipPairs = [
    { round1: "col_round1_m", round2: "col_round2_m" },
    { round1: "strat_round1_m", round2: "strat_round2_m" },
    { round1: "per_round1_m", round2: "per_round2_m" },
    { round1: "vis_round1_m", round2: "vis_round2_m" },
  ];

  useEffect(() => {
    const variableMap = apiData?.variables?.reduce((acc, el) => {
      acc[el.variable] = el.score;
      return acc;
    }, {});

    // console.log("variableMap", variableMap);
    setVariableMapArray(variableMap);
  }, [apiData]);

  useEffect(() => {
    if (apiData?.variables) {
      // console.log("apiData.variables", apiData.variables);
      const variableMap = apiData.variables.reduce((acc, el) => {
        acc[el.variable] = el.score;
        return acc;
      }, {}) || {};

      if (Object.keys(variableMap).length === 0) return;

      const performance_r1_m = variableMap["per_round1_m"] || 0;
      const strategic_r1_m = variableMap["strat_round1_m"] || 0;
      const visionary_r1_m = variableMap["vis_round1_m"] || 0;
      const collaborative_r1_m = variableMap["col_round1_m"] || 0;

      const performance_r2_m = variableMap["per_round2_m"] || 0;
      const strategic_r2_m = variableMap["strat_round2_m"] || 0;
      const visionary_r2_m = variableMap["vis_round2_m"] || 0;
      const collaborative_r2_m = variableMap["col_round2_m"] || 0;

      const performance_r1_l = variableMap["per_round1_l"] || 0;
      const strategic_r1_l = variableMap["strat_round1_l"] || 0;
      const visionary_r1_l = variableMap["vis_round1_l"] || 0;
      const collaborative_r1_l = variableMap["col_round1_l"] || 0;

      const performance_r2_l = variableMap["per_round2_l"] || 0;
      const strategic_r2_l = variableMap["strat_round2_l"] || 0;
      const visionary_r2_l = variableMap["vis_round2_l"] || 0;
      const collaborative_r2_l = variableMap["col_round2_l"] || 0;

      let most_score = Math.max(performance_r1_m, strategic_r1_m, visionary_r1_m, collaborative_r1_m);
      let second_most_score = Math.max(performance_r2_m, strategic_r2_m, visionary_r2_m, collaborative_r2_m) / 2;
      let least_score = Math.max(performance_r1_l, strategic_r1_l, visionary_r1_l, collaborative_r1_l);
      let second_least_score = Math.max(performance_r2_l, strategic_r2_l, visionary_r2_l, collaborative_r2_l) / 2;

      if (least_score >= second_least_score) {
        least_score = second_least_score - 1;
      }

      const total = most_score + second_most_score + least_score + second_least_score;

      const most_per = (most_score / total) * 100;
      const second_most_per = (second_most_score / total) * 100;
      const least_per = (least_score / total) * 100;
      const second_least_per = (second_least_score / total) * 100;

      const labels_arr = ["performance", "strategic", "visionary", "collaborative"];

      const mostValues = [performance_r1_m, strategic_r1_m, visionary_r1_m, collaborative_r1_m];
      const secondMostValues = [performance_r2_m, strategic_r2_m, visionary_r2_m, collaborative_r2_m];
      const leastValues = [performance_r1_l, strategic_r1_l, visionary_r1_l, collaborative_r1_l];
      const secondLeastValues = [performance_r2_l, strategic_r2_l, visionary_r2_l, collaborative_r2_l];

      const getLabel = (values, maxValue) => labels_arr[values.indexOf(maxValue)];

      const most_label = getLabel(mostValues, Math.max(...mostValues));
      const second_most_label = getLabel(secondMostValues, Math.max(...secondMostValues));
      const least_label = getLabel(leastValues, Math.max(...leastValues));
      const second_least_label = getLabel(secondLeastValues, Math.max(...secondLeastValues));

      const leadershipPercentages = {
        strategic: 0,
        visionary: 0,
        performance: 0,
        collaborative: 0
      };
      leadershipPercentages[most_label] = most_per;
      leadershipPercentages[second_most_label] = second_most_per;
      leadershipPercentages[least_label] = least_per;
      leadershipPercentages[second_least_label] = second_least_per;

      const sorted = applyFullTieOrder(
        Object.entries(leadershipPercentages).sort((a, b) => b[1] - a[1]),
        ([name]) => name,
        ([, value]) => value
      );

      // console.log("LeadershipFlowPreview360 - Self calculation results:", leadershipPercentages);
      // console.log("LeadershipFlowPreview360 - Self calculation sorted:", sorted);
      // console.log("LeadershipFlowPreview360 - Highest leadership style:", most_label);
      // console.log("LeadershipFlowPreview360 - Self raw percentages:", { most_per, second_most_per, least_per, second_least_per });
      // console.log("LeadershipFlowPreview360 - Self labels:", { most_label, second_most_label, least_label, second_least_label });

      setHighestLeadership(most_label);
      setSelfScoreRanking(sorted);
      setSelfAverages(leadershipPercentages);

      const getPercentageOrder = (label) => {
        if (label === most_label?.toLowerCase()) return most_per;
        if (label === second_most_label?.toLowerCase()) return second_most_per;
        if (label === least_label?.toLowerCase()) return least_per;
        if (label === second_least_label?.toLowerCase()) return second_least_per;
        return 0;
      };

      const sortedResults = sorted.map(([label, percentage]) => percentage);
      const sortedLabels = sorted.map(([label, percentage]) => label);

      setLeadershipSnapshotResults(sortedResults);
      setLeadershipLabels(sortedLabels);
    }
  }, [apiData]);

  const calculate360AggregatedData = () => {
    if (!apiData?.memberResults?.allMembersData) {
      return;
    }

    const allMembersData = apiData.memberResults.allMembersData;
    const assessmentResults = [];

    // console.log('LeadershipFlowPreview360 - Processing 360 assessments:', allMembersData);

    Object.values(allMembersData).forEach(memberAssessment => {
      if (!memberAssessment?.variables) return;
      const variables = {};
      memberAssessment.variables.forEach(variable => {
        variables[variable.variable] = variable.score;
      });

      // console.log("LeadershipFlowPreview360 - Member", memberAssessment.userName, "variables:", variables);

      const performance_r1_m = variables["per_round1_m"] || 0;
      const strategic_r1_m = variables["strat_round1_m"] || 0;
      const visionary_r1_m = variables["vis_round1_m"] || 0;
      const collaborative_r1_m = variables["col_round1_m"] || 0;
      const performance_r2_m = variables["per_round2_m"] || 0;
      const strategic_r2_m = variables["strat_round2_m"] || 0;
      const visionary_r2_m = variables["vis_round2_m"] || 0;
      const collaborative_r2_m = variables["col_round2_m"] || 0;
      const performance_r1_l = variables["per_round1_l"] || 0;
      const strategic_r1_l = variables["strat_round1_l"] || 0;
      const visionary_r1_l = variables["vis_round1_l"] || 0;
      const collaborative_r1_l = variables["col_round1_l"] || 0;
      const performance_r2_l = variables["per_round2_l"] || 0;
      const strategic_r2_l = variables["strat_round2_l"] || 0;
      const visionary_r2_l = variables["vis_round2_l"] || 0;
      const collaborative_r2_l = variables["col_round2_l"] || 0;

      const most_scores = [performance_r1_m, strategic_r1_m, visionary_r1_m, collaborative_r1_m];
      const second_most_scores = [performance_r2_m, strategic_r2_m, visionary_r2_m, collaborative_r2_m].map(score => score / 2);
      const least_scores = [performance_r1_l, strategic_r1_l, visionary_r1_l, collaborative_r1_l];
      const second_least_scores = [performance_r2_l, strategic_r2_l, visionary_r2_l, collaborative_r2_l].map(score => score / 2);
      const most_score = Math.max(...most_scores);
      const second_most_score = Math.max(...second_most_scores);
      let least_score = Math.max(...least_scores);
      const second_least_score = Math.max(...second_least_scores);
      if (least_score >= second_least_score) {
        least_score = second_least_score - 1;
      }
      const total = most_score + second_most_score + least_score + second_least_score;
      const most_per = (most_score / total) * 100;
      const second_most_per = (second_most_score / total) * 100;
      const least_per = (least_score / total) * 100;
      const second_least_per = (second_least_score / total) * 100;
      const labels_arr = ["performance", "strategic", "visionary", "collaborative"];
      const mostValues = [performance_r1_m, strategic_r1_m, visionary_r1_m, collaborative_r1_m];
      const secondMostValues = [performance_r2_m, strategic_r2_m, visionary_r2_m, collaborative_r2_m];
      const leastValues = [performance_r1_l, strategic_r1_l, visionary_r1_l, collaborative_r1_l];
      const secondLeastValues = [performance_r2_l, strategic_r2_l, visionary_r2_l, collaborative_r2_l];
      const most_score_label = Math.max(...mostValues);
      const second_most_score_label = Math.max(...secondMostValues);
      const least_score_label = Math.max(...leastValues);
      const second_least_score_label = Math.max(...secondLeastValues);
      const getLabel = (values, maxValue) => labels_arr[values.indexOf(maxValue)];
      const most_label = getLabel(mostValues, most_score_label);
      const second_most_label = getLabel(secondMostValues, second_most_score_label);
      const least_label = getLabel(leastValues, least_score_label);
      const second_least_label = getLabel(secondLeastValues, second_least_score_label);
      const getPercentageOrder = (label) => {
        if (label === most_label?.toLowerCase()) return most_per;
        if (label === second_most_label?.toLowerCase()) return second_most_per;
        if (label === least_label?.toLowerCase()) return least_per;
        if (label === second_least_label?.toLowerCase()) return second_least_per;
        return 0;
      };

      const results = [
        getPercentageOrder("performance"),
        getPercentageOrder("collaborative"),
        getPercentageOrder("visionary"),
        getPercentageOrder("strategic")
      ];

      // console.log("LeadershipFlowPreview360 - Member", memberAssessment.userName, "results:", results);
      assessmentResults.push({ results });
    });

    const averageResults = assessmentResults.reduce((acc, curr) => {
      curr.results.forEach((score, index) => {
        if (!acc[index]) acc[index] = 0;
        acc[index] += score;
      });
      return acc;
    }, []).map(total => total / assessmentResults.length);

    // console.log('LeadershipFlowPreview360 - Average results calculated:', averageResults);

    if (assessmentResults.length > 0) {
      const labels = [
        { name: 'Performance', value: averageResults[0] },
        { name: 'Collaborative', value: averageResults[1] },
        { name: 'Visionary', value: averageResults[2] },
        { name: 'Strategic', value: averageResults[3] },
      ];
      const sortedLabels = applyFullTieOrder(averagePercentagesLeadership.slice().sort((a, b) => b.avg - a.avg), (l) => l.name, (l) => l.avg);
      const sortedValues = sortedLabels.map(l => (Number(l.avg) || 0).toFixed(2));

      // console.log('LeadershipFlowPreview360 - Sorted labels:', sortedLabels);
      // console.log('LeadershipFlowPreview360 - Sorted values:', sortedValues);

      setThree60ScoreRanking(sortedLabels.map((label, index) => [label.name.toLowerCase(), (Number(label.avg) || 0).toFixed(2)]));
      setThree60Averages({
        performance: averagePercentagesLeadership?.find((el) => el.name == "Performance").avg,
        collaborative: averagePercentagesLeadership?.find((el) => el.name == "Collaborative").avg,
        visionary: averagePercentagesLeadership?.find((el) => el.name == "Visionary").avg,
        strategic: averagePercentagesLeadership?.find((el) => el.name == "Strategic").avg
      });

      setAggregated360Results([
        averagePercentagesLeadership?.find((el) => el.name == "Performance").avg,
        averagePercentagesLeadership?.find((el) => el.name == "Collaborative").avg,
        averagePercentagesLeadership?.find((el) => el.name == "Visionary").avg,
        averagePercentagesLeadership?.find((el) => el.name == "Strategic").avg
      ]);
      setAggregated360Labels(["performance", "collaborative", "visionary", "strategic"]);
    }
  };

  useEffect(() => {
    calculate360AggregatedData();

  }, [apiData?.memberResults, averagePercentagesLeadership]);

  const getValue = (key, averages) => {
    return averages[key] !== undefined ? (Number(averages[key]) || 0).toFixed(2) : '0.00';
  };


  const FLOW_CONTENT = {
    'CS': {
      title: 'You flow from Collaborative to Strategic',
      details: [
        'When Collaborative Leaders grow into Strategic Leadership, they take their people skills and apply them to clear planning, organization, and alignment. You still care deeply about your team. Now you help them understand the plan, the structure, and how decisions fit together.',
        'Your awareness of team needs helps you spot obstacles early and design plans that work in real conditions. This creates a leadership style that is both organized and people-focused. The result is smoother coordination, clearer priorities, and a team that knows how their work fits into the bigger picture.'
      ]
    },
    'CV': {
      title: 'You flow from Collaborative to Visionary',
      details: [
        'When Collaborative Leaders grow into Visionary Leadership, they shift from creating a supportive, people-first environment to inspiring others with a bigger picture. You still lead through trust and connection. Now you help people see beyond today’s tasks and understand the larger impact of their work.',
        'Your relational strengths expand into a broader sense of purpose. You bring people together around a shared direction and explain why the work matters. This blend of care and purpose motivates the team and strengthens commitment to long-term goals.'
      ]
    },
    'CP': {
      title: 'You flow from Collaborative to Performance',
      details: [
        'When Collaborative Leaders grow into Performance Leadership, they bring their relational strengths into a more results-focused approach. You are skilled at creating environments where people feel valued. Now you also want to turn that positive culture into measurable progress.',
        'You set specific goals, raise standards, and direct the team toward real outcomes. You support people while also challenging them and keeping momentum high. Your understanding of team dynamics helps you push others toward excellence without losing connection along the way.'
      ]
    },
    'SC': {
      title: 'You flow from Strategic to Collaborative',
      details: [
        'When Strategic Leaders grow into Collaborative Leadership, they shift from directing to involving. You still create structure and clarity, but now you pay more attention to team dynamics and individual contributions.',
        'You invite others into discussions, value their input, and design plans that reflect the strengths and needs of the group. This balance produces strong execution supported by genuine buy-in.'
      ]
    },
    'SV': {
      title: 'You flow from Strategic to Visionary',
      details: [
        'When Strategic Leaders grow into Visionary Leadership, they combine practical planning with deeper purpose and direction. You continue to think systematically, but now you also focus on meaning, long-term impact, and inspiration.',
        'You connect roles and tasks to a larger story so the team understands why their work matters. This creates a culture that values both clarity and purpose.'
      ]
    },
    'SP': {
      title: 'You flow from Strategic to Performance',
      details: [
        'When Strategic Leaders grow into Performance Leadership, they channel their planning abilities into focused execution and measurable outcomes. You still value structure and strategy, but now your attention shifts to speed, efficiency, and results.',
        'You break strategies into concrete steps, manage resources effectively, and drive progress with discipline. This helps the team move from planning to consistent performance.'
      ]
    },
    'VS': {
      title: 'You flow from Visionary to Strategic',
      details: [
        'When Visionary Leaders grow into Strategic Leadership, they begin grounding their big ideas and creativity in practical, actionable plans. You still think in terms of purpose and long-term impact. Now you also focus on the systems, structures, and data needed to turn those ideas into reality.',
        'You keep your inspirational energy, but you balance it with planning, priorities, and risk awareness. This combination helps your vision become both inspiring and achievable.'
      ]
    },
    'VC': {
      title: 'You flow from Visionary to Collaborative',
      details: [
        'When Visionary Leaders grow into Collaborative Leadership, they combine their innovative ideas with a more inclusive, team-centered approach. You recognize that your vision becomes stronger when others help shape it.',
        'You create space for open communication and shared ownership. This approach builds trust and ensures that people feel connected to the direction of the work, not just informed about it.'
      ]
    },
    'VP': {
      title: 'You flow from Visionary to Performance',
      details: [
        'When Visionary Leaders grow into Performance Leadership, they connect their bold ideas to concrete results. You start translating the big picture into clear goals, real actions, and disciplined follow-through.',
        'You continue to inspire, but you now focus on execution and measurable progress. This blend of imagination and action brings your ideas to life in a way that feels both creative and practical for the team.'
      ]
    },
    'PC': {
      title: 'You flow from Performance to Collaborative',
      details: [
        'When Performance Leaders grow into Collaborative Leadership, they expand from focusing mainly on results to valuing teamwork and shared ownership. You begin balancing high standards with openness, communication, and feedback.',
        'You involve people in decisions and recognize individual strengths. This shift helps create a team culture where people feel respected, supported, and motivated to contribute.'
      ]
    },
    'PV': {
      title: 'You flow from Performance to Visionary',
      details: [
        'When Performance Leaders grow into Visionary Leadership, they direct their energy and drive toward larger, transformative goals. You start thinking beyond immediate results and consider the long-term impact of your work.',
        'You articulate a compelling future, encourage creativity, and give your team a sense of purpose behind their efforts. This brings new meaning to the fast-paced action you excel at.'
      ]
    },
    'PS': {
      title: 'You flow from Performance to Strategic',
      details: [
        'When Performance Leaders grow into Strategic Leadership, they take their results-driven mindset and apply it to long-term planning and organizational design. You still value execution, but now you think in terms of systems, priorities, and sustainable growth.',
        'You help the team understand not just what needs to get done, but why it matters for the future. This shift turns strong performers into leaders who can build lasting structures and guide the organization forward.'
      ]
    }
  }

  const getQuadrantLabel = (key) => {
    const labelMap = {
      'collaborative': 'Collaborative',
      'visionary': 'Visionary',
      'strategic': 'Strategic',
      'performance': 'Performance'
    };
    return labelMap[key] || key;
  };

  const SquareWithArrow = ({ scoreRanking, averages }) => {
    const quadrantPositions = {
      'collaborative': {
        labelStyle: { position: 'absolute', bottom: '5px', right: '10px', color: '#000', fontSize: '24px', fontWeight: 'bold' },
        percentStyle: { position: 'absolute', bottom: '30px', right: '10px', color: '#000', fontSize: '24px', fontWeight: 'bold' },
        center: { x: 280, y: 260 }
      },
      'visionary': {
        labelStyle: { position: 'absolute', bottom: '5px', left: '10px', color: '#000', fontSize: '24px', fontWeight: 'bold' },
        percentStyle: { position: 'absolute', bottom: '30px', left: '10px', color: '#000', fontSize: '24px', fontWeight: 'bold' },
        center: { x: 90, y: 260 }
      },
      'strategic': {
        labelStyle: { position: 'absolute', top: '5px', left: '10px', color: '#000', fontSize: '24px', fontWeight: 'bold' },
        percentStyle: { position: 'absolute', top: '30px', left: '10px', color: '#000', fontSize: '24px', fontWeight: 'bold' },
        center: { x: 90, y: 90 }
      },
      'performance': {
        labelStyle: { position: 'absolute', top: '5px', right: '10px', color: '#000', fontSize: '24px', fontWeight: 'bold' },
        percentStyle: { position: 'absolute', top: '30px', right: '10px', color: '#000', fontSize: '24px', fontWeight: 'bold' },
        center: { x: 280, y: 90 }
      }
    };

    const createDynamicPath = () => {
      if (!scoreRanking || scoreRanking.length === 0) {
        return "M 90 90 L 280 260 L 90 260 L 280 90";
      }

      const orderedPositions = scoreRanking.map(([quadrant, percentage]) => {
        const position = quadrantPositions[quadrant];
        return position ? position.center : { x: 185, y: 175 };
      });

      if (orderedPositions.length === 0) {
        return "M 90 90 L 280 260 L 90 260 L 280 90";
      }

      let pathString = `M ${orderedPositions[0].x} ${orderedPositions[0].y}`;
      for (let i = 1; i < orderedPositions.length; i++) {
        pathString += ` L ${orderedPositions[i].x} ${orderedPositions[i].y}`;
      }

      return pathString;
    };

    return (
      <div style={{ transform: 'scale(0.45)', transformOrigin: 'top left', width: '164px', height: '174px', }} >
        <div style={{ position: 'relative', width: '371px', height: '352px', backgroundColor: 'transparent', display: 'flex', justifyContent: 'center', alignItems: 'center', border: '2px solid #000' }}>
          <div style={{ position: 'absolute', width: '2px', height: '100%', backgroundColor: '#000' }}></div>
          <div style={{ position: 'absolute', width: '100%', height: '2px', backgroundColor: '#000' }}></div>

          {/* Static quadrant labels and percentages in fixed positions */}
          {Object.keys(quadrantPositions).map(quadrant => {
            const position = quadrantPositions[quadrant];
            const percentage = getValue(quadrant, averages);
            const label = getQuadrantLabel(quadrant);

            return (
              <div key={quadrant}>
                <div style={position.labelStyle}>{label}</div>
                <div style={position.percentStyle}>{percentage}%</div>
              </div>
            );
          })}

          <svg width="371" height="352" style={{ position: 'absolute', top: '0', left: '0' }}>
            {scoreRanking && scoreRanking.length > 0 && (
              <circle cx={quadrantPositions[scoreRanking[0][0]]?.center.x || 90} cy={quadrantPositions[scoreRanking[0][0]]?.center.y || 90} r="10" fill="#B6111F" />
            )}

            <path d={createDynamicPath()} stroke="#B6111F" strokeWidth="5" fill="none" markerEnd="url(#arrowhead)" />
            <defs>
              <marker id="arrowhead" markerWidth="5" markerHeight="5" refX="3" refY="2.5" orient="auto">
                <polygon points="0 0, 5 2.5, 0 5" fill="#B6111F" />
              </marker>
            </defs>
          </svg>
        </div>
      </div>
    );
  };


  const styles = {
    heading: { fontFamily: "Helvetica, sans-serif", fontWeight: 700, fontStyle: "normal", fontSize: "14px", lineHeight: "18px", letterSpacing: "0px", textTransform: "uppercase", color: "#00577D", margin: 0, padding: "16px 0px" },
    paragraph: { fontFamily: "Helvetica, sans-serif", fontWeight: 400, fontStyle: "normal", fontSize: "10px", lineHeight: "14px", letterSpacing: "0px", color: "#000000", margin: "0 0 16px 0" }
  };

  const FLOW_IMAGES = {
    'CP': flow_CP,
    'CS': flow_CS,
    'CV': flow_CV,
    'PC': flow_PC,
    'PS': flow_PS,
    'PV': flow_PV,
    'SC': flow_SC,
    'SP': flow_SP,
    'SV': flow_SV,
    'VC': flow_VC,
    'VP': flow_VP,
    'VS': flow_VS,
  };


  const leadershipShort = {
    strategic: 'S',
    performance: 'P',
    visionary: 'V',
    collaborative: 'C'
  };



  function getFlowContent(leadershipSnapshotResults, leadershipLabels) {
    if (!leadershipSnapshotResults || !leadershipLabels || leadershipSnapshotResults.length !== 4 || leadershipLabels.length !== 4) {
      return FLOW_CONTENT['CS']; // Default fallback
    }

    const pairs = leadershipLabels.map((label, i) => ({
      label: label.toLowerCase(),
      score: leadershipSnapshotResults[i]
    }));
    const sorted = applyFullTieOrder([...pairs].sort((a, b) => b.score - a.score), (p) => p.label, (p) => p.score);
    const highest = sorted[0].label;
    const secondHighest = sorted[1].label;
    const flowKey = `${leadershipShort[highest]}${leadershipShort[secondHighest]}`;

    return FLOW_CONTENT[flowKey] || FLOW_CONTENT['CS']; // Fallback to CS if not found
  }


  function getLeadershipFlowImage(leadershipSnapshotResults, leadershipLabels) {
    if (!leadershipSnapshotResults || !leadershipLabels || leadershipSnapshotResults.length !== 4 || leadershipLabels.length !== 4) return null;
    const pairs = leadershipLabels.map((label, i) => ({
      label: label.toLowerCase(),
      score: leadershipSnapshotResults[i]
    }));
    const sorted = applyFullTieOrder([...pairs].sort((a, b) => b.score - a.score), (p) => p.label, (p) => p.score);
    const highest = sorted[0].label;
    const secondHighest = sorted[1].label;
    const flowKey = `${leadershipShort[highest]}${leadershipShort[secondHighest]}`;
    return FLOW_IMAGES[flowKey];
  }

  // This page shows the 360 (observer) flow; the self answers are only a fallback until those scores load.
  const has360Leadership = averagePercentagesLeadership?.length === 4;
  const flowResults = has360Leadership ? averagePercentagesLeadership.map((el) => el.avg) : leadershipSnapshotResults;
  const flowLabels = has360Leadership ? averagePercentagesLeadership.map((el) => el.name) : leadershipLabels;
  const flowContent = getFlowContent(flowResults, flowLabels);


  return (
    <>
      <div style={{ backgroundColor: "rgb(255, 255, 255)" }}>
        <HeaderPreview />
        <div className="">
          <h4 style={styles.heading}>LEADERSHIP FLOW</h4>
          <p style={styles.paragraph}>
            Just like you have a Starter Quadrant and a Flow Type™, your leadership has a natural starting point and a movement pattern. The problem is that most leaders over-rely on one style. That strength becomes a limitation, while other leadership styles go underused or unrecognized.
          </p>
          <p style={styles.paragraph}>
            Your Leadership Flow shows how you lead under pressure, how you make decisions, and how you influence others. Often, your third and fourth styles hold untapped potential that sits beneath an overdeveloped primary strength.
          </p>
          <p style={styles.paragraph}>Teams and organizations need all four styles to thrive: Collaborative, Visionary, Strategic, and Performance Leadership. When even one is missing, alignment and performance begin to suffer.</p>
          <p style={styles.paragraph}>
            <span style={{ fontWeight: "700", paddingBottom: "5px" }}> Expand Your Range: </span>Lead beyond your default style.<br />
            <span style={{ fontWeight: "700", paddingBottom: "5px" }}>Diagnose the Gaps: </span> Identify what is missing in your team.<br />
            <span style={{ fontWeight: "700" }}> Reclaim Hidden Strengths: </span>Activate strengths that have been underused.
          </p>
          <p style={styles.paragraph}>You do not have to be all things at once. You do need access to it all.</p>
        </div>
        <h4 style={{ fontFamily: "Helvetica, sans-serif", fontWeight: 700, fontStyle: "normal", fontSize: "11px", lineHeight: "15px", letterSpacing: "0px", color: "#00577D", margin: 0, marginBottom: "16px" }}>{flowContent.title} (360)</h4>
        <div style={{ display: 'flex', gap: '16px', alignItems: 'start' }}>
          {flowResults.length === 4 && flowLabels.length === 4 && (
            <img src={getLeadershipFlowImage(flowResults, flowLabels)} alt="Leadership Flow" style={{ width: '108px', height: '108px', flexShrink: 0 }} />
          )}
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'start', }} >
            <p style={{ fontFamily: "Helvetica, sans-serif", fontWeight: 400, fontStyle: "normal", fontSize: "10px", lineHeight: "14px", letterSpacing: "0px", color: "#000000", margin: 0, marginBottom: "16px" }} >
              {flowContent.details[0]}
            </p>
            <p style={{ fontFamily: "Helvetica, sans-serif", fontWeight: 400, fontStyle: "normal", fontSize: "10px", lineHeight: "14px", letterSpacing: "0px", color: "#000000", margin: 0 }} >
              {flowContent.details[1]}
            </p>
          </div>
        </div>

        <FooterPreview pageNumber={pageNumber} reportType={reportType} />
      </div>
    </>
  );
}